"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../../../../../common/js/BaseComponent");
var ProductFilter = /** @class */ (function (_super) {
    __extends(ProductFilter, _super);
    function ProductFilter($view) {
        var _this = _super.call(this, $view) || this;
        _this.TEMPLATE_PRODUCTS = 'products';
        _this.productsContainerId = '#products-container';
        _this.filtersContainerId = '.category-filter';
        _this.selectedFilters = {};
        _this.hashCurrent = null;
        _this.hashKey = null;
        _this.cache = {};
        _this.productsOrder = 1;
        _this.productsQuantity = 12;
        _this.productsPage = "1";
        _this.productsPageRegex = /\#?\&?p=(\d+)/i;
        _this.productsQuantityRegex = /\#?\&?q=(\d+)/i;
        _this.productsOrderRegex = /\#?\&?t=(\d+)/i;
        _this.productsFiltreRegex = /\#?\&?f=(\d+)/i;
        _this.initEvents();
        if (window.location.hash !== "") {
            _this.updateContentFromHash();
        }
        return _this;
    }
    ProductFilter.getContainer = function (containerId) {
        var $container = $(containerId);
        if ($container === undefined || $container.length === 0) {
            console.error('Container not found - Id : ' + containerId);
        }
        return $container;
    };
    ProductFilter.prototype.getProductsContainer = function () {
        return ProductFilter.getContainer(this.productsContainerId);
    };
    ProductFilter.prototype.getFiltersContainer = function () {
        return ProductFilter.getContainer(this.filtersContainerId);
    };
    /**
     * Analyse hash, and update content with hash params
     */
    ProductFilter.prototype.updateContentFromHash = function () {
        this.hashCurrent = window.location.hash;
        this.hashKey = this.hashCurrent.replace(/^#/, '');
        // Update current page from current hash
        this.updatePaginationFromHash();
        this.updateQuantityFromHash();
        this.updateOrderFromHash();
        this.getCurrentProductsContent();
        this.updateCheckedOption(this.selectedFilters);
    };
    /**
     * Update CurrentPage using current URL hash
     */
    ProductFilter.prototype.updatePaginationFromHash = function () {
        var match = this.productsPageRegex.exec(this.hashCurrent);
        if (match) {
            // Update the products current page
            this.productsPage = match[1];
        }
    };
    /****
     ***
     * Mettre à jour les checkboxes de filtre
     ***/
    ProductFilter.prototype.updateCheckedOption = function (selectedFiltres) {
        if (selectedFiltres) {
            var _loop_1 = function (filtre) {
                var selectedValue = selectedFiltres[filtre];
                var selectedFiltre = document.querySelectorAll('[data-filter="' + filtre + '"]');
                [].forEach.call(selectedFiltre, function (checkboxFiltre) {
                    [].forEach.call(selectedValue, function (sValue) {
                        if (checkboxFiltre.value === sValue) {
                            checkboxFiltre.checked = true;
                        }
                    });
                });
            };
            for (var filtre in selectedFiltres) {
                _loop_1(filtre);
            }
        }
    };
    /**
     * Update Quantity using current URL hash
     */
    ProductFilter.prototype.updateQuantityFromHash = function () {
        var match = this.productsQuantityRegex.exec(this.hashCurrent);
        if (match) {
            // Update the products current page
            this.productsQuantity = match[1];
        }
    };
    /**
     * Update Order using current URL hash
     */
    ProductFilter.prototype.updateOrderFromHash = function () {
        var match = this.productsOrderRegex.exec(this.hashCurrent);
        if (match) {
            // Update the products current page
            this.productsOrder = match[1];
        }
    };
    /**
     * Retrieve the content adapted to the current selected filters
     */
    ProductFilter.prototype.getCurrentProductsContent = function () {
        // Check if cache content exist
        if (this.isCurrentFilterCached()) {
            // If it does, then show the cached content
            this.updateContent();
        }
        else {
            // If not, then request for content and cache it
            this.sendFilterRequest();
        }
    };
    /**
     * Check if system has already load the current requested hashKey
     */
    ProductFilter.prototype.isCurrentFilterCached = function () {
        var _this = this;
        var isCached = true;
        if (!this.cache.hasOwnProperty(this.hashKey)) {
            this.cache[this.hashKey] = {};
            isCached = false;
        }
        $.each(this.cache[this.hashKey], function (key) {
            if (isCached === false)
                return;
            isCached = $.inArray(key, [_this.TEMPLATE_PRODUCTS]) > -1;
        });
        return isCached;
    };
    /**
     * Save retrieved data into cache object
     * @param content
     */
    ProductFilter.prototype.pushCachedData = function (content) {
        this.cache[this.hashKey].filters = content.filters;
        this.cache[this.hashKey].products = content.products;
    };
    /**
     * Update the content of the page with current hashKey
     */
    ProductFilter.prototype.updateContent = function () {
        var data = this.cache[this.hashKey];
        if (data) {
            this.getProductsContainer().empty().append(data.products);
            this.getFiltersContainer().empty().append(data.filters);
        }
        this.reLunchComponents();
    };
    ProductFilter.prototype.reLunchComponents = function () {
        $('.product-card .product-favorite').each(function () {
            // @ts-ignore
            Kernel.factories.Favorite($(this));
        });
        $('.product-card .comparator-checkbox').each(function () {
            // @ts-ignore
            Kernel.factories.AddComparator($(this));
        });
        $('.product-card .add-to-cart').each(function () {
            // @ts-ignore
            Kernel.factories.AddCartFromItem($(this));
        });
    };
    /**
     * Update hash class params and propagate the new hash into the URL
     */
    ProductFilter.prototype.updateHash = function () {
        var _this = this;
        this.hashKey = '1';
        /*
         * Hash for products
         */
        this.hashKey += '&p=' + this.productsPage;
        this.hashKey += '&q=' + this.productsQuantity;
        this.hashKey += '&t=' + this.productsOrder;
        $.each(this.selectedFilters, function (key, filterValues) {
            _this.hashKey += '&f' + key + '=' + filterValues.join(',');
        });
        window.location.hash = '#' + this.hashKey;
    };
    /**
     * Build current url
     */
    ProductFilter.prototype.buildUrl = function () {
        return window.location.origin + window.location.pathname;
    };
    /**
     * Send request with template required to response,
     * filters, pages, orders, quantities
     */
    ProductFilter.prototype.sendFilterRequest = function () {
        var _this = this;
        $.ajax({
            url: this.buildUrl(),
            data: {
                p: this.productsPage,
                q: this.productsQuantity,
                t: this.productsOrder,
                filters: this.selectedFilters
            },
            success: function (data) {
                // Save retrieved data to cache array
                _this.pushCachedData(data);
                // Then update content
                _this.updateContent();
                //Mettre à jour les checbox
                _this.updateCheckedOption(data.selectedFiltre);
            }
        });
    };
    /**
     * Update hash url and products contents
     */
    ProductFilter.prototype.refreshHashAndContent = function () {
        this.updateHash();
        this.getCurrentProductsContent();
    };
    /**
     * Init all page events
     */
    ProductFilter.prototype.initEvents = function () {
        this.initBlockEvents();
        this.initBlockFiltersEvents();
        this.initSlideFilter();
    };
    ProductFilter.prototype.initSlideFilter = function () {
        var _this = this;
        this.$view.find("#hide-filters").on('click', function () {
            _this.$view.find('#list-filters').toggle();
        });
        this.$view.find(".mod>a").on('click', function (e) {
            _this.$view.find('#' + $(e.target).data('show')).toggle('slow');
        });
    };
    ProductFilter.prototype.initBlockEvents = function () {
        var _this = this;
        this.getProductsContainer().off('click');
        this.getProductsContainer()
            .on('click', '.pagination a', function (e) {
            e.preventDefault();
            _this.productsPage = $(e.target).closest('a').attr('href').split('page=')[1];
            _this.refreshHashAndContent();
        });
        this.getFiltersContainer().off('click');
        $(document).on('change', '.sort-by select', function (e) {
            e.preventDefault();
            console.log('filtre');
            _this.productsOrder = $(e.target).val();
            _this.refreshHashAndContent();
        });
    };
    ProductFilter.prototype.initBlockFiltersEvents = function () {
        var _this = this;
        this.getFiltersContainer().off('change', 'click');
        this.getFiltersContainer()
            .on('change', 'input[type="checkbox"][data-filter]', function (e) {
            var $el = $(e.target);
            _this.clearFilters();
            _this.manageFilters($el.data('filter'), $el.val());
            _this.refreshHashAndContent();
            $el.prop("checked", true);
        })
            .on('click', '.cancel', function (e) {
            e.preventDefault();
            _this.selectedFilters = {};
            _this.clearFilters();
            _this.updateHash();
            _this.updateContentFromHash();
            _this.$view.find('input[type="number"]').val('');
            _this.$view.find('input[type=checkbox]').prop('checked', false);
            _this.$view.find('input[type=radio]').prop('checked', false);
            _this.getCurrentProductsContent();
            _this.refreshHashAndContent();
        });
    };
    ProductFilter.prototype.manageFilters = function (filterId, filterValue, renew) {
        if (renew === void 0) { renew = null; }
        if (!this.selectedFilters.hasOwnProperty(filterId) || renew === true) {
            this.selectedFilters[filterId] = [];
        }
        var index;
        if ((index = $.inArray(filterValue, this.selectedFilters[filterId])) > -1) {
            this.selectedFilters[filterId].splice(index, 1);
            if (this.selectedFilters[filterId].length === 0) {
                delete this.selectedFilters[filterId];
            }
        }
        else {
            this.selectedFilters[filterId].push(filterValue);
        }
    };
    ProductFilter.prototype.clearFilters = function () {
        this.productsPage = "1";
    };
    return ProductFilter;
}(BaseComponent_1.default));
exports.default = ProductFilter;
;
